import { render, staticRenderFns } from "./AddBonCommande.vue?vue&type=template&id=60d90b90"
import script from "./AddBonCommande.vue?vue&type=script&lang=js"
export * from "./AddBonCommande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports